import { InputField } from 'components/InputField';
import { LabelField } from "components/LabelField";
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const BanQuestForm = ({formik,disabled}) => {
  return (
    <Row>
      <Col className="col-sm-6">
        <LabelField title="Source key" mandatory hint="Your BanQuest gateway source key, found in your BanQuest merchant dashboard. Required together with the PIN." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: 'none',
            formStyle: { marginBottom: 0 },
            name: 'source_key',
            placeholder: 'Source key',
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.banquest?.source_key}
          handleChange={(e) => {
            formik.setFieldValue('banquest.source_key', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
      <Col className="col-sm-6" >
        <LabelField title="PIN" mandatory hint="Your BanQuest gateway PIN, found alongside the Source key in your BanQuest merchant dashboard." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: "none",
            formStyle: { marginBottom: 0 },
            name: "pin",
            placeholder: "PIN",
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.banquest?.pin}
          handleChange={(e) => {
            formik.setFieldValue('banquest.pin', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
    </Row>
  )
}

export default BanQuestForm